import MessageSection from '@able/react/dist/MessageSection';
import { MessageSectionProps } from '@able/react/dist/MessageSection';
import { useTableHeaderContext } from './TableContext';

const TableMessage = () => {
    const {
        tableMessageDescription,
        tableMessageTitle,
        developmentUrl,
        tableMessageVariant,
        tableMessageTitleElement,
        tableMessageActionElement,
        tableMessageActionId,
        tableMessageActionText,
        tableMessageActionRef,
        tableMessageActionLink,
        tableMessageActionCallback
    } = useTableHeaderContext();

    return (
        <MessageSection description={tableMessageDescription as string}
            titleElement={tableMessageTitleElement}
            titleText={tableMessageTitle}
            developmentUrl={developmentUrl}
            actionElement={tableMessageActionElement}
            actionId={tableMessageActionId}
            actionText={tableMessageActionText}
            actionRef={tableMessageActionRef}
            actionLink={tableMessageActionLink}
            actionCallback={tableMessageActionCallback}
            variant={tableMessageVariant as MessageSectionProps['variant']} />
    );
}

export default TableMessage